import React from 'react';
import {
  Create,
  Edit,
  EditButton,
  Filter,
  List,
  maxLength,
  minLength,
  required,
  SearchInput,
  TextField,
  TextInput,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import BulkDeleteButton from '../../components/BulkDeleteButton';

const ServiceCustomMessageFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const ServiceCustomMessageList = ({ classes, ...props }) => (
  <div>
    <List
      {...props}
      filters={<ServiceCustomMessageFilter />}
      bulkActionButtons={<BulkDeleteButton />}
      sort={{ field: 'custom_message_id', order: 'ASC' }}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="created_at" />
        <TextField source="modified_at" />
        <TextField source="custom_message_id" />
        <TextField source="internal_name" />
        <TextField source="booking_review_message" />
        <TextField source="logistics_message" />
        <EditButton />
      </ZippityDatagrid>
    </List>
    <p>
      The <strong>Booking Review Message</strong> is displayed as a superscript
      number on the{' '}
      <a href="/screenshots/checkout-message.png" target="_blank">
        final page of the booking process
      </a>{' '}
      (e.g., Bulb Replacement <sup>[1]</sup>
      ).
    </p>
    <p>
      The <strong>Logistics Message</strong> is sent in 3 customer notifications
      (both email and SMS):{' '}
      <a href="https://zippitycars.github.io/email/dist/1_confirmation.html">
        Confirmation
      </a>
      ,{' '}
      <a href="https://zippitycars.github.io/email/dist/2_reminder.html">
        Day-Before Reminder
      </a>
      , and{' '}
      <a href="https://zippitycars.github.io/email/dist/3_checkin.html">
        Day-Of Checkin
      </a>
      .
    </p>
  </div>
);

const editStyles = {};

const validateInternalName = [required(), minLength(2), maxLength(63)];
const validateMessage = [maxLength(1023)];

export const ServiceCustomMessageEdit = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Edit undoable={false} {...props}>
      <ZippitySimpleForm>
        <TextInput validate={validateInternalName} source="internal_name" />
        <TextInput
          multiline
          validate={validateMessage}
          source="booking_review_message"
        />
        <TextInput
          multiline
          validate={validateMessage}
          source="logistics_message"
        />
      </ZippitySimpleForm>
    </Edit>
  ),
);

export const ServiceCustomMessageCreate = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Create {...props}>
      <ZippitySimpleForm>
        <TextInput validate={validateInternalName} source="internal_name" />
        <TextInput
          multiline
          validate={validateMessage}
          source="booking_review_message"
        />
        <TextInput
          multiline
          validate={validateMessage}
          source="logistics_message"
        />
      </ZippitySimpleForm>
    </Create>
  ),
);
